import React, { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import '../../../styles/RichTextEditor.scss'

interface RichTextEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
                                                           value,
                                                           onChange,
                                                           placeholder,
                                                       }) => {
    const editor = useEditor({
        extensions: [
            StarterKit,
        ],

        content: value || "",

        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },

        editorProps: {
            attributes: {
                class: "tiptap-editor",
            },
        },
    });

    useEffect(() => {
        if (!editor) {
            return;
        }

        const currentContent = editor.getHTML();

        if (value !== currentContent) {
            editor.commands.setContent(value || "", {
                emitUpdate: false,
            });
        }
    }, [value, editor]);

    if (!editor) {
        return null;
    }

    return (
        <div
            className="tiptap-wrapper"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        >
            <div className="tiptap-toolbar">
                <button
                    type="button"
                    className={editor.isActive("bold") ? "is-active" : ""}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        editor.chain().focus().toggleBold().run();
                    }}
                    title="Bold"
                >
                    <strong>B</strong>
                </button>

                <button
                    type="button"
                    className={editor.isActive("bulletList") ? "is-active" : ""}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        editor.chain().focus().toggleBulletList().run();
                    }}
                    title="Bullet list"
                >
                    •
                </button>

                <button
                    type="button"
                    className={editor.isActive("orderedList") ? "is-active" : ""}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        editor.chain().focus().toggleOrderedList().run();
                    }}
                    title="Numbered list"
                >
                    1.
                </button>
            </div>

            <div className="tiptap-editor-container">
                <EditorContent editor={editor} />
                {placeholder && !editor.getText() && (
                    <div className="tiptap-placeholder">
                        {placeholder}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RichTextEditor;
